import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { SalaryProfile } from "../../components/SalaryProfile";

export const SalaryProfilePage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Salary"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
      ]}
      mainContents={<SalaryProfile testId="Salary-Profile" />}
    />
  );
};
